<template>
    <div style="position: relative;">
      <div class="dialog-title-adm">
        <slot name="title"></slot>
      </div>
      <slot name="content"></slot>
      <slot name="btn">
      </slot>
      <slot name="close">
      </slot>
    </div>
</template>
<script>
export default {
  name: 'base-dialog-layout',
  data () {
    return {
    }
  }
}
</script>
<style lang="stylus" scoped>
.dialog-title-adm
  font-size: 22px;
  font-weight: bolder;
  letter-spacing: 1.2px;

.v-dialog
  .base-btn-primary
    margin: 20px 0px 0px!important;
  .base-btn-primary.flex
    display flex
    .v-btn
      flex: unset!important;
      width: unset
.v-dialog .base-btn-primary.flex .v-btn+.v-btn
    width: 140px!important;
    margin-left: 20px;

.close-x
  width: 45px;
  height: 45px;
  background-color: #fff38d;
  color: #4a4a4a;
  position: absolute;
  padding-left: 7px;
  top: 0;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  right: 0;
</style>
